/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-12 14:26:48
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-12 19:01:52
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorMaintenancePage/tools.ts
 */
import _ from 'lodash';
import { randomNumber } from '@/src/tools/helper';
import {
  defaultCollapse,
  EnumCollapseId,
} from 'src/pages/SalesCannelVersion/SalesChannelEditorMaintenancePage/common';
import { reduxUpdatedStatusControl } from 'src/tools/helper';
import { linkModulesContentValidation } from 'src/constrains/DraggableModules/tools';
import { errCodesMap } from 'src/error/code';
import { generateDefaultText } from 'src/pages/SalesCannelVersion/SalesChannelEditorMaintenancePage/common';
import {
  isUserValid,
  salesChannelResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
  EPermissionSource,
} from '@/src/types/common/resources';
const permissions = (uuid: string) => {
  //view_maintenance_page
  const edit_maintenance_page = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelMaintenancePage,
        subCategory: EnumSubCategory.ChannelMaintenancePage,
        operation: EnumOperation.edit_maintenance_page,
        uuid,
      }),
    ],
  });
  return { edit_maintenance_page };
};
const validateMaintenanceLongCanvas = (longCanvas = [], isPrimary?) => {
  const generalError = [];
  if (longCanvas.length < 1) {
    generalError.push(errCodesMap['999990']);
  }
  const errs = linkModulesContentValidation(longCanvas);

  return {
    hasError: errs.hasError || generalError.length > 0,
    specificError: errs.moduleError,
    generalError,
  };
};

const convertDataFromServerToRedux = (data, isPrimary?) => {
  const {
    uuid,
    salesChannelContent,
    salesChannelName,
    storeUuid,
    longCanvas,
    salesChannelUuid,
    content,
    //hasError,
  } = data;
  const isNew = !uuid;

  const linkModules = _.get(longCanvas, 'linkModules', []);
  const _linkModules = Array.isArray(linkModules)
    ? linkModules.map((m) => ({
        ...m,
        draggableId: m?.draggableId || randomNumber(),
      }))
    : [];
  const { collapseOpen, collapseErrorMsgDisplay } = defaultCollapse(!isNew);

  if (!isNew) {
    let flag = false;
    const { hasError: longCanvasHasError } = validateMaintenanceLongCanvas(
      _linkModules,
      isPrimary,
    );

    if (longCanvasHasError) {
      collapseErrorMsgDisplay[EnumCollapseId.longCanvas].hasError = true;
      collapseErrorMsgDisplay[EnumCollapseId.longCanvas].display = true;
      if (!flag) {
        flag = true;
        collapseOpen[EnumCollapseId.longCanvas] = true;
      }
    }
  }

  return {
    storeUuid,
    uuid,
    longCanvas: _linkModules,
    salesChannelContent,
    salesChannelName,
    collapseOpen,
    collapseErrorMsgDisplay,
    salesChannelUuid,
    content: content || generateDefaultText(),
    ...reduxUpdatedStatusControl,
  };
};

const convertDataFromReduxToServer = (state) => {
  const setting = _.cloneDeep(state);
  const { longCanvas, storeUuid, uuid, salesChannelUuid, content } = setting;
  return {
    uuid,
    storeUuid,
    salesChannelUuid,
    longCanvas: {
      moduleName: 'LongCanvas',
      moduleType: 'LongCanvas',
      visible: true,
      linkModules: longCanvas,
    },
    content,
  };
};

export {
  convertDataFromReduxToServer,
  convertDataFromServerToRedux,
  validateMaintenanceLongCanvas,
  permissions,
};
